<template>
  <div>

    <div class="my-5 is-success" v-if="loading" style="max-width:250px">
      <b-progress></b-progress>
    </div>

    <div v-else class="">
      <div v-if="!policy.errors" class="columns mt-3" style="margin: 0; border-radius: 10px">
        <div class="column">
          <div class="container">
            <div v-if="policy.data.cancelPenalties" class="mb-3">
              <h3 class="is-size-5">Cancellation Policy</h3>
              <div v-for="(cancelPenalty, index) in policy.data.cancelPenalties" :key="index">
                <b-tag v-if="cancelPenalty.nonrefundable" type="is-danger is-light">Non-refundable</b-tag>
                <CancelPenalty :cancelPenalty="cancelPenalty"></CancelPenalty>
              </div>
            </div>
            <div v-else-if="cancelPolicy" class="mb-3">
              <h3 class="is-size-5">Cancel Policy</h3>
              <li v-for="item in cancelPolicy" :key="item" class="is-size-7">
                {{ item._ }}
              </li>
            </div>
          </div>
          <div class="container mb-3" v-if="policy.data.features.length > 0">
            <div>
              <h3 class="is-size-5">Features</h3>
              <div class="content">
                <ul>
                  <li class="is-size-7" v-for="item in policy.data.features" :key="item">
                    {{ item }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="container mb-3" v-if="rateDescription">
            <div>
              <h3 class="is-size-5">Details</h3>

              <!-- <li class="is-size-7" v-for="item in rateDescription" :key="item._">
                    {{ item._}}
                  </li> -->

              <span class="is-size-7" v-for="item in rateDescription" :key="item._">
                {{ item._ }}
              </span>
            </div>
          </div>
          <div v-if="hotelDates.length > 0" class="mb-3">
            <h3 class="is-size-5 mb-2">Daily Price Breakdown</h3>

            <div class="priceBreakdown" style="max-width:250px">
              <div class="" style="max-height: 120px; overflow: auto;">
                <ul class="is-marginless mb-2 mr-2">
                  <li class="is-flex is-flex-direction-row is-justify-content-space-between" v-for="date in hotelDates"
                    :key="`date_${date.id}`">
                    <div class="is-size-7 ">
                      {{ $moment(date.startDate).format("ddd, MMM D") }}
                    </div>
                    <div class="is-size-7 ">{{ formatCurrency(date.title) }}</div>
                  </li>
                </ul>
              </div>
              <hr class="is-marginless is-paddingless mb-1" />
              <div class="mb-3 mr-2">
                <!-- Should we include note that amount if after tax if no beforeTax amount is given? -->
                <div class="is-flex is-flex-direction-row is-justify-content-space-between">
                  <div class="is-size-7 has-text-weight-bold">
                    Subtotal
                  </div>
                  <div class="is-size-7 has-text-weight-bold">
                    {{ formatCurrency(calculatedSubtotal) }}
                  </div>
                </div>

                <div class="is-flex is-flex-direction-row is-justify-content-space-between" v-if="calculatedTax > 0">
                  <span class="is-size-7 ">
                    Tax
                  </span>
                  <span class="is-size-7">{{ formatCurrency(calculatedTax) }}</span>
                </div>

                <hr class="is-marginless is-paddingless mb-1" style="height:4px" />

                <div class="is-flex is-flex-direction-row is-justify-content-space-between">
                  <div class="is-size-7 has-text-weight-bold">
                    Estimated total
                  </div>
                  <div class="is-size-7 has-text-weight-bold">{{ formatCurrency(calculatedTotal) }}</div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!policy.errors">
        <div v-if="policy.data.AdditionalDetail">
          <p class="is-size-7" v-for="item in policy.data.AdditionalDetail" :key="item._">
            {{ item._ }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CancelPenalty from "./CancelPenalty";
import bookingMixin from "@/mixins/bookingMixin";

export default {
  name: "EnhancedPricingTab",
  mixins: [bookingMixin],
  components: {
    CancelPenalty,
  },
  props: {
    sol: Object,
    session: String,
  },
  data: function () {
    return {
      isOpen: 0,
      policy: null,
      loading: true,
      liveResults: []
    };
  },
  computed: {
    cancelPolicy() {
      try {
        if (Array.isArray(this.policy.data.cancelPenalty.Description)) {
          return this.policy.data.cancelPenalty.Description;
        } else if (this.policy.data.cancelPenalty.Description == null) {
          return null;
        } else {
          return [this.policy.data.cancelPenalty.Description];
        }
      } catch {
        return null;
      }
    },
    rateDescription() {
      try {
        if (Array.isArray(this.policy.data.RatePlanDescription.Text)) {
          return this.policy.data.RatePlanDescription.Text;
        } else if (this.policy.data.RatePlanDescription.Text == null) {
          return null;
        } else {
          return [this.policy.data.RatePlanDescription.Text];
        }
      } catch {
        return null;
      }
    },
    hotelDates() {
      let dates = this.sol.enhancedPricing.dailyRates;
      let hDates = [];
      for (let hDate of dates) {
        let dateObj = {
          id: hDate.date,
          startDate: hDate.date,
          endDate: hDate.date,
          title: hDate.amount,
        };

        hDates.push(dateObj);
      }

      return hDates;
    },
    calculatedSubtotal() {
      let subtotal = 0;

      if (this.sol.originalPricing.AmountBeforeTax) {
        return Number(this.sol.originalPricing.AmountBeforeTax);
      }

      let dates = this.sol.enhancedPricing.dailyRates;
      for (let hDate of dates) {
        subtotal = subtotal + hDate.amount;
      }

      return subtotal;
    },
    calculatedTotal() {
      if (this.sol.originalPricing.AmountAfterTax) {
        return Number(this.sol.originalPricing.AmountAfterTax);
      } else {
        return Number(this.sol.originalPricing.AmountBeforeTax);
      }

    },
    calculatedTax() {
      // let tax = Number(this.sol.originalPricing.AmountAfterTax) - Number(this.sol.originalPricing.AmountBeforeTax)
      let tax = this.calculatedTotal - this.calculatedSubtotal;

      return tax;
    },
    originalCurrencyCode(){
      return this.sol.originalPricing.CurrencyCode;
    }
  },
  methods: {
    // For now we will use this instead of mapping currency codes to symbols
    formatCurrency(amount) {

      if (typeof amount === 'string') {
        amount = Number(amount);
      }

      if (this.originalCurrencyCode === 'USD') {
        return `$${amount.toFixed(2)}`;
      } else {
        return `${amount.toFixed(2)} ${this.originalCurrencyCode}`;
      }
    },
    async getRules() {
      let bookingCode = this.sol.enhancedPricing.bookingCode;

      if (this.liveResults.length > 0 && this.sol.infoSourceReference) {
        bookingCode = this.extractBookingCode();
      }

      if (!this.session) {
        this.updateKey({});
        return;
      }

      var raw = {
        stateful: true,
        sessionKey: this.session,
        normalizeResponse: true,
        hotelCode: this.setHotelReference(),
        checkInDate: this.sol.startDate,
        checkOutDate: this.sol.endDate,
        roomCount: 1,
        guestCount: 1,
        roomTypeCode: this.sol.enhancedPricing.roomTypeCode,
        bookingCode: bookingCode,
        ratePlanCode: this.sol.enhancedPricing.ratePlanCode,
        ratePlanType: null,
        mealPlanCode: null,
      };

      try {
        this.$app
          .huddleLabsServerCall("amadeus/hotel/enhanced-pricing", raw)
          .then((result) => {
            this.updateKey(result);
          });
      } catch {
        this.loading = false;
        this.policy.error = true;
      }
    },
    async updateKey(result) {
      if (result.errors && result.errors.length > 0) {
        if (result.errors[0].code == "SCM" || result.errors[0].code == "SCI") {
          var body = {
            stateful: true,
            sessionKey: this.session,
            requestedCurrency: "USD",
            normalizeResponse: true,
            travelerContactId: this.$store.getters[
              "travellersAndTrips/getCurrentTravellerProfile"
            ].id,
            travelPolicyId: this.$store.getters[
              "travellersAndTrips/getCurrentTravellerProfile"
            ].travelPolicyId,
            hotelCode: this.sol.hotelCode,
            checkInDate: this.sol.startDate,
            checkOutDate: this.sol.endDate,
            roomCount: 1,
            guestCount: 1,
            ratePlanCodes: [],
          };

          this.$app
            .huddleLabsServerCall("amadeus/hotel/live-search", body)
            .then((result) => {
              this.liveResults = result.data
              this.getRules();
            });
        } else {
          this.policy = result;
          this.loading = false;
          // console.log(result.error);
        }
      } else {
        this.policy = result;
        this.loading = false;
        // console.log(result.error);
      }
    },
    setHotelReference() {
      if (!this.sol.infoSourceReference) {
        return this.sol.hotelCode
      } else {
        return this.sol.infoSourceReference
      }

    },
    extractBookingCode() {

      let bookingCode = null;

      let liveResult = this.liveResults.find(result => {
        return result.hotelCode === this.sol.hotelCode;
      });

      if (liveResult && Array.isArray(liveResult.rooms)) {
        // Find matching room
        let matchingRoom = liveResult.rooms.find(room => {
          return (
            room.infoSourceReference === this.sol.infoSourceReference &&
            room.textDescription === this.sol.textDescription &&
            room.sourceCurrencyPricing.total === this.sol.sourceCurrencyPricing.total &&
            room.guaranteeType === this.sol.guaranteeType &&
            room.enhancedPricing.ratePlanCode === this.sol.enhancedPricing.ratePlanCode &&
            room.enhancedPricing.roomTypeCode === this.sol.enhancedPricing.roomTypeCode
          );
        });

        if (matchingRoom) {
          bookingCode = matchingRoom.enhancedPricing.bookingCode;
        } else {
          // TODO throw error
        }

      }

      // Return the extracted bookingCode
      return bookingCode;
    }
  },
  mounted() {
    if (this.policy === null) {
      this.getRules();
    }
  },
};
</script>

<style scoped>
hr {
  background-color: rgb(214, 213, 213);
}
</style>
